<template>
  <div ref="root" @scroll="onscroll">
  	<slot></slot>
  </div>
</template>

<script type="text/javascript">
export default {
	name: 'inhibit-scroll-container',
	props: {
		name: { // used to disambiguate state in scrolly.inhibitScrollSources
			type: String,
			required: true,
		},
		visible: {
			type: Boolean,
			required: true,
		},
		horizontal: {
			type: Boolean,
			required: false,
			defaultValue: false,
		},
	},
	data() {
	  return {
	    up: false,
	    down: false,
	  };
	},
	computed: {
		effectiveInhibit() {
			if (!this.visible) return { up: false, down: false };
			return { up: this.up && this.toStart, down: this.down && this.toEnd };
		},
	},
	watch: {
	  up() { this.$emit('inhibit', this.name, this.effectiveInhibit) },
	  down() { this.$emit('inhibit', this.name, this.effectiveInhibit) },
	  visible() { this.$emit('inhibit', this.name, this.effectiveInhibit) }, 
	},
	methods: {
		onscroll(e) {
		  const c = this.$refs.root;
		  const distance = !this.horizontal ? c.scrollTop : c.scrollLeft;
		  const totalDistance = !this.horizontal ? c.scrollHeight - c.clientHeight : c.scrollWidth - c.clientWidth;
		  
			this.$emit('scrolled', {
		    distance,
		    totalDistance,
		    progress: distance / totalDistance,
		  });
		  
		  this.up = distance > 2;
		  this.down = distance < totalDistance - 2;
		},
		toStart() {
			if (!this.horizontal) {
				this.$refs.root.scrollTop = 0;
			} else {
				this.$refs.root.scrollLeft = 0;
			}
		},
		toEnd() {
			if (!this.horizontal) {
				this.$refs.root.scrollTop = this.$refs.root.scrollHeight;
			} else {
				this.$refs.root.scrollLeft = this.$refs.root.scrollWidth;
			}
		},
	},
	mounted() {
		console.log('horizontal', this.horizontal)
		this.$emit('inhibit', this.name, this.effectiveInhibit)
	},
	beforeUnmount() {
		this.$emit('inhibit', this.name, {up: false, down: false})
	},
	updated() {
	  this.onscroll();
	},
};
</script>
